import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import ProfileAvatar, { ProfileBadgeSize } from "./ProfileAvatar";
import ProfileHandle from "./ProfileHandle";
import ProfileLevel, { ProfileLevelSize } from "./ProfileLevel";
import type { CICType } from "@/entities/IProfile";
interface ProfileBadgeProps {
  readonly handle?: string | null | undefined;
  readonly href?: string | undefined;
  readonly pfpUrl?: string | null | undefined;
  readonly level: number;
  readonly cicType: CICType;
  readonly size?: ProfileBadgeSize | undefined;
  readonly className?: string | undefined;
  readonly children?: ReactNode | undefined;
  readonly avatarAlt?: string | undefined;
  readonly avatarFallback?: ReactNode | undefined;
  readonly highlightSearchParam?: string | undefined;
  readonly asLink?: boolean | undefined;
}
const LEVEL_SIZE_MAP: Record<ProfileBadgeSize, ProfileLevelSize> = {
  [ProfileBadgeSize.SMALL]: ProfileLevelSize.SMALL,
  [ProfileBadgeSize.MEDIUM]: ProfileLevelSize.MEDIUM,
  [ProfileBadgeSize.LARGE]: ProfileLevelSize.LARGE
};
export default function ProfileBadge(t0) {
  const $ = _c(23);
  const {
    handle,
    href,
    pfpUrl,
    level,
    cicType,
    size: t1,
    className,
    children,
    avatarAlt,
    avatarFallback,
    highlightSearchParam,
    asLink: t2
  } = t0;
  const size = t1 === undefined ? ProfileBadgeSize.MEDIUM : t1;
  const asLink = t2 === undefined ? true : t2;
  const t3 = `tw-flex tw-items-center tw-gap-x-2 ${className ?? ""}`;
  let t4;
  if ($[0] !== avatarAlt || $[1] !== avatarFallback || $[2] !== pfpUrl || $[3] !== size) {
    t4 = <ProfileAvatar pfpUrl={pfpUrl} alt={avatarAlt} fallbackContent={avatarFallback} size={size} />;
    $[0] = avatarAlt;
    $[1] = avatarFallback;
    $[2] = pfpUrl;
    $[3] = size;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = LEVEL_SIZE_MAP[size];
  let t6;
  if ($[5] !== cicType || $[6] !== level || $[7] !== t5) {
    t6 = <ProfileLevel level={level} cicType={cicType} size={t5} />;
    $[5] = cicType;
    $[6] = level;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== asLink || $[10] !== handle || $[11] !== highlightSearchParam || $[12] !== href || $[13] !== size) {
    t7 = <ProfileHandle handle={handle} href={href} asLink={asLink} size={size} highlightSearchParam={highlightSearchParam} />;
    $[9] = asLink;
    $[10] = handle;
    $[11] = highlightSearchParam;
    $[12] = href;
    $[13] = size;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-text-center">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== children || $[19] !== t3 || $[20] !== t4 || $[21] !== t8) {
    t9 = <div className={t3}>{t4}{t8}{children}</div>;
    $[18] = children;
    $[19] = t3;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}